import styled from "styled-components";
import { cuideoTheme } from "../../../../containers/themes/defaultTheme";

export const MobileList = styled.div`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  width: 100%;
  overflow: hidden;
`;

export const MobileDayBox = styled.div`
  border: 1px solid #c2d1da;
  border-radius: 5px;
  overflow: hidden;
  background: #fff;
  & + & {
    margin-top: 8px;
  }
`;

export const MobileDayRow = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e8eff3;
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  background: #f5fbff;
`;

export const MobileDayLabel = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: ${cuideoTheme.palette.primary.main};
`;

export const MobileEventRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.4rem 1rem 0.4rem 0.5rem;
  border-bottom: 1px solid #e8eff3;
`;

export const TimeSelectGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
`;

export const TimeSelect = styled.select`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
  border: 1px solid #c2d1da;
  border-radius: 4px;
  padding: 4px 2px;
  background: #fff;
  outline: none;
  &:focus { border-color: ${cuideoTheme.palette.secondary.main}; }
`;

export const TimeSeparator = styled.span`
  font-size: 0.85rem;
  color: ${cuideoTheme.palette.primary.main};
  padding: 0 4px;
`;

export const MobileDeleteButton = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${cuideoTheme.palette.error.main};
  color: #fff;
  font-size: 0.6rem;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;
  &:hover { background: #d43050; }
`;

export const AddEventButton = styled.div`
  margin: 0.4rem 1rem;
  padding: 0.4rem 1rem;
  font-size: 0.8rem;
  color: ${cuideoTheme.palette.secondary.main};
  border: 1px solid ${cuideoTheme.palette.secondary.main};
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  text-align: center;
  &:hover { background: rgba(91, 192, 190, 0.1); }
`;

export const MobileCopyButton = styled.button<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid ${({ $disabled }) => ($disabled ? "#c2d1da" : cuideoTheme.palette.primary.main)};
  border-radius: 4px;
  color: ${({ $disabled }) => ($disabled ? "#c2d1da" : cuideoTheme.palette.primary.main)};
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  padding: 2px 8px;
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  &:hover {
    background: ${({ $disabled }) => ($disabled ? "none" : "rgba(38, 70, 83, 0.08)")};
  }
`;
